import { navigate } from "gatsby";
import React from "react";

import Image from "../../../components/image";
import Logo from "../../../images/gvi-logo2.inline.svg";
import ArrowRight from "../../../images/icons/arrow-right.inline.svg";
import BlogSvg from "../../../images/icons/blog-dark.inline.svg";
import BlogLightSvg from "../../../images/icons/blog-light.inline.svg";
import FacebookSvg from "../../../images/icons/facebook-dark.inline.svg";
import FacebookLightSvg from "../../../images/icons/facebook-light.inline.svg";
import DownloadSvg from "../../../images/icons/fi-rr-download.inline.svg";
import GridDarkIcon from "../../../images/icons/fi-rr-grid-dark.inline.svg";
import GridLightIcon from "../../../images/icons/fi-rr-grid-light.inline.svg";
import GoogleScholarLight from "../../../images/icons/google-scholar-logo-light.svg";
import GoogleScholarLogo from "../../../images/icons/google-scholar-logo.svg";
import InstagramDark from "../../../images/icons/instagram-dark.png";
import InstagramLightSvg from "../../../images/icons/instagram-light.inline.svg";
import LinkedINSvg from "../../../images/icons/linkedin-dark.inline.svg";
import LinkedINLightSvg from "../../../images/icons/linkedin-light.inline.svg";
import PhoneIcon from "../../../images/icons/phone-icon.inline.svg";
import TickTokSvg from "../../../images/icons/tiktok-dark.inline.svg";
import TickTokLightSvg from "../../../images/icons/tiktok-light.inline.svg";
import YoutubeSvg from "../../../images/icons/youtube-dark.inline.svg";
import YoutubeLightSvg from "../../../images/icons/youtube-light.inline.svg";
import { Link } from "../../../utils/customLink";

function formatMenu(data) {
  const result = data.map((child) => ({
    type: "link",
    node: child?.label || "",
    url: child?.url || "",
    // databaseId: child.databaseId,
    description: child?.description || "",
    cssClasses: child?.cssClasses || [],
    subMenu: child?.children?.nodes ?? child?.children
  }));

  for (const child of result) {
    if (
      child?.subMenu &&
      Array.isArray(child.subMenu) &&
      child.subMenu.length
    ) {
      child.type = "menu";
      child.subMenu = formatMenu(child.subMenu);
    }
  }

  return result;
}

function changeParent(nodes, label) {
  let found = false;
  for (let idx = 0; idx < nodes.length; idx++) {
    const node = nodes[idx];
    if (label === node?.node) {
      const parent = nodes[idx - 1];
      const children = parent.subMenu ?? [];
      children.push({
        node: (
          <div className="text-sm text-black-lighter planet:text-white !font-semibold pt-4">
            {label}
          </div>
        ),
        type: "component"
      });

      node.subMenu &&
        children.push(
          ...node.subMenu.map((child) => ({
            node: child.node,
            type: child.subMenu && !child.subMenu.length ? "link" : "menu",
            url: child.url
          }))
        );

      parent.subMenu = children;

      parent.type = "menu";

      nodes.splice(idx, 1);
      return true;
    }

    if (node?.subMenu && Array.isArray(node.subMenu)) {
      found = changeParent(node.subMenu, label);
    }

    if (found) {
      return true;
    }
  }

  return false;
}

function searchNode(nodes, label) {
  for (const node of nodes) {
    if (label === node.node) {
      return node;
    }

    if (node.children) {
      const parent = searchNode(node.subMenu, label);
      if (parent) {
        return parent;
      }
    }
  }
}

function array_move(arr, old_index, new_index) {
  if (new_index >= arr.length) {
    var k = new_index - arr.length + 1;
    while (k--) {
      arr.push(undefined);
    }
  }
  arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
  return arr;
}

export function formatForException(
  data,
  site,
  socialmedia,
  brochures,
  intlNumber,
  secondarySiteUrl,
  colorMode
) {
  const result = formatMenu(data);

  // Exceptions
  // Find a program
  let node =
    searchNode(result, "Programs abroad") ||
    searchNode(result, "Programs overseas");

  if (node) {
    const item = {
      node: (
        <button
          className="flex w-full mt-4 px-8 py-2 bg-white planet:bg-gray-standard justify-center items-center rounded-full planet:rounded-xxs"
          onClick={() => navigate("/find-a-program")}
        >
          <GridLightIcon className="block planet:hidden" />
          <GridDarkIcon className="hidden planet:block" />
          <span className="h6 pl-2 font-semibold text-black-lighter planet:text-white tracking-[0.02em]">
            Find a program
          </span>
        </button>
      ),

      type: "component"
    };

    const switchApp = {
      node: (
        <div className="py-4">
          <p className="text-xs text-black-lighter planet:text-white">
            Go to GVI`s community development programs
          </p>
          <div className="flex items-center pt-4">
            <a
              href={secondarySiteUrl ?? "#"}
              className="cursor-pointer flex items-center"
            >
              <Logo className="w-10 fill-black-lighter planet:fill-white" />
              <span className="text-black-lighter planet:text-white pl-4 pr-2 uppercase font-semibold text-xs menu-link tracking-[0.19em]">
                {site.siteMetadata.sec_nav_title}
              </span>
              <ArrowRight className="w-3 h-3 stroke-green-standard planet:stroke-red-light gvi-text-green" />
            </a>
          </div>
        </div>
      ),
      type: "component"
    };

    searchNode(result[0]?.subMenu, "Volunteer")?.subMenu.unshift(item);
    searchNode(result[0]?.subMenu, "Intern")?.subMenu.unshift(item);
    searchNode(
      result[0]?.subMenu,
      "Professional apprenticeships"
    )?.subMenu.unshift(item);
    searchNode(result[0]?.subMenu, "Research fellowship")?.subMenu.unshift(
      item
    );

    searchNode(result[0]?.subMenu, "Under 18");

    //expand group programs and professional courses
    const groupPrograms =
      searchNode(result[0]?.subMenu, "Group programs") ?? "";
    const professionalCourses =
      searchNode(result[0]?.subMenu, "Professional courses") ?? "";

    const groupsMenu =
      groupPrograms?.subMenu?.map((child) => ({
        type: "menu",
        node: child?.node,
        url: child?.url
      })) ?? [];
    groupsMenu?.forEach((menuListItem) => {
      result[0]?.subMenu?.push(menuListItem);
    });

    const coursesMenu =
      professionalCourses?.subMenu?.map((child) => ({
        type: "menu",
        node: child?.node,
        url: child?.url
      })) ?? [];

    coursesMenu?.forEach((menuListItem) => {
      result[0]?.subMenu?.push(menuListItem);
    });

    if (node?.subMenu) {
      node?.subMenu?.unshift(item);
      if (groupsMenu?.length > 0 && coursesMenu?.length > 0) {
        array_move(node?.subMenu, 7, 11);
      }
      node?.subMenu?.push(switchApp);
    } else {
      node.subMenu = [item];
    }
  }

  // Under 18, By type, By focus change parent
  // changeParent(result, "Under 18");
  changeParent(result, "By type");
  changeParent(result, "By focus");

  //Split Why Gvi menu into SubMenu Why GVI and About US

  let parentWhyGvi = searchNode(result, "Why GVI");
  const whyGvi = parentWhyGvi?.subMenu?.splice(0, 5);
  const aboutUs = parentWhyGvi?.subMenu?.splice(0, 4);

  if (result[4]?.subMenu) result[4].subMenu = [];
  result[4]?.subMenu?.push({ type: "menu", node: "Why GVI", subMenu: whyGvi });
  result[4]?.subMenu?.push({
    type: "menu",
    node: "About us",
    subMenu: aboutUs
  });

  //Find a Program
  result[3].type = "menu";

  const locationsText = secondarySiteUrl?.includes("people")
    ? "To view our community development locations"
    : "To view our conservation locations";

  //Locations menu
  let locationsNode = searchNode(result, "Locations");
  locationsNode?.subMenu?.push({
    node: (
      <div className="flex items-center mt-4">
        <div className="inline-block text-base font-normal h6 menu-link text-black-lighter planet:text-gray-darken">
          {locationsText},
          <Link
            to={`${secondarySiteUrl}?nav_switcher=1`}
            className="font-bold pl-1 text-black-lighter planet:text-white"
          >
            click here
          </Link>
        </div>
      </div>
    ),
    type: "component"
  });

  //Connect with us
  const connectWithUs = {
    node: "Connect with us",

    type: "menu",
    subMenu: [
      {
        node: (
          <div className="text-mob text-black-lighter planet:text-white !font-semibold !font-body">
            Stay up to Date
          </div>
        ),
        type: "component"
      },
      {
        node: (
          <div className="flex py-4 border-b border-gray-generic">
            <BlogSvg className="hidden w-5 pr-1 planet:block" />
            <BlogLightSvg className="block w-5 pr-1 planet:hidden" />
            <Link
              className="my-auto text-xs text-black-lighter planet:text-gray-darken"
              to={socialmedia?.blog}
            >
              Read our Blog
            </Link>
          </div>
        ),
        type: "component"
      },
      {
        node: (
          <div className="flex py-4 border-b border-gray-generic">
            <Link
              className="my-auto text-xs text-black-lighter planet:text-gray-darken"
              to={socialmedia?.google_scholar}
              target={"_gviblank"}
              rel={"nofollow"}
            >
              View our publications on
            </Link>
            <Image
              imageAlt={"Google Scholar"}
              image={""}
              imageClass={`w-24 pl-1 hidden planet:block`}
              sourceUrl={GoogleScholarLogo}
            />
            <Image
              imageAlt={"Google Scholar"}
              image={""}
              imageClass={`w-24 pl-1 block planet:hidden`}
              sourceUrl={GoogleScholarLight}
            />
          </div>
        ),
        type: "component"
      },
      {
        node: (
          <div className="text-mob text-black-lighter planet:text-white !font-semibold pt-4 !font-body">
            Follow Us
          </div>
        ),
        type: "component"
      },
      {
        node: (
          <div className="flex py-4 border-b border-gray-generic">
            <Image
              imageAlt=""
              image={""}
              imageClass="hidden w-5 pr-1 planet:block"
              sourceUrl={InstagramDark}
            />
            <InstagramLightSvg className="block w-5 pr-1 planet:hidden" />
            <Link
              className="my-auto text-xs text-black-lighter planet:text-gray-darken"
              to={socialmedia?.instagram}
            >
              Instagram
            </Link>
          </div>
        ),
        type: "component"
      },
      {
        node: (
          <div className="flex py-4 border-b border-gray-generic">
            <TickTokSvg className="hidden w-5 pr-1 planet:block" />
            <TickTokLightSvg className="block w-5 pr-1 planet:hidden" />
            <Link
              className="my-auto text-xs text-black-lighter planet:text-gray-darken"
              to={socialmedia?.tiktok}
            >
              Tik Tok
            </Link>
          </div>
        ),
        type: "component"
      },
      {
        node: (
          <div className="flex py-4 border-b border-gray-generic">
            <YoutubeSvg className="hidden w-5 pr-1 planet:block" />
            <YoutubeLightSvg className="block w-5 pr-1 planet:hidden" />
            <Link
              className="my-auto text-xs text-black-lighter planet:text-gray-darken"
              to={socialmedia?.youtube}
            >
              YouTube
            </Link>
          </div>
        ),
        type: "component"
      },
      {
        node: (
          <div className="flex py-4 border-b border-gray-generic">
            <LinkedINSvg className="hidden w-5 pr-1 planet:block fill-[#0077B5]" />
            <LinkedINLightSvg className="block w-5 pr-1 planet:hidden" />
            <Link
              className="my-auto text-xs text-black-lighter planet:text-gray-darken"
              to={socialmedia?.linkedin}
            >
              LinkedIn
            </Link>
          </div>
        ),
        type: "component"
      },
      {
        node: (
          <div className="flex py-4 border-b border-gray-generic">
            <FacebookSvg className="w-5 pr-1 hidden planet:block fill-[#1877F2]" />
            <FacebookLightSvg className="block w-5 pr-1 planet:hidden" />
            <Link
              className="my-auto text-xs text-black-lighter planet:text-gray-darken"
              to={socialmedia?.facebook}
            >
              Facebook
            </Link>
          </div>
        ),
        type: "component"
      },
      {
        node: (
          <div className="flex py-4 border-b border-gray-generic">
            <DownloadSvg className="w-5 pr-1 fill-yellow-standard planet:fill-white" />
            <Link
              className="my-auto text-xs text-black-lighter planet:text-gray-darken"
              to={brochures?.brochure_dl}
            >
              Download a brochure
            </Link>
          </div>
        ),
        type: "component"
      }
    ]
  };
  result.push(connectWithUs);

  //Push Call us
  result.push({
    node: (
      <Link
        className="flex items-center mt-4 text-white gvi-gray-text"
        to={`tel: ${intlNumber}`}
      >
        <PhoneIcon className="w-10 h-10 mr-4 flex fill-white planet:fill-[#141414] bg-black-lighter planet:bg-gray-darken rounded-full" />
        <div className="inline-block text-base font-normal h6 menu-link text-black-lighter planet:text-gray-darken">
          Call us
        </div>
      </Link>
    ),
    type: "component"
  });
  return result;
}
